const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13281 5.83353C2.13281 4.65532 3.08794 3.7002 4.26615 3.7002H21.3328C22.511 3.7002 23.4661 4.65532 23.4661 5.83353V20.7669C23.4661 21.9451 22.511 22.9002 21.3328 22.9002H4.26615C3.08794 22.9002 2.13281 21.9451 2.13281 20.7669V5.83353ZM21.3328 5.83353L4.26615 5.83353V20.7669H21.3328V5.83353ZM19.7328 10.6335H5.86615V8.5002H19.7328V10.6335ZM19.7328 14.3669H5.86615V12.2335H19.7328V14.3669ZM17.5995 18.1002H5.86615V15.9669H17.5995V18.1002Z",
    fill: "#1D313D",
    style: {
      fill: "#1D313D",
      fill: "color(display-p3 0.1137 0.1922 0.2392)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.34f4bb5687daf72ed71a001c2497b4d9.svg";
export { ForwardRef as ReactComponent };